import { useCallback } from 'react';

import { fetchBadges } from '../pages/Badges/BadgesSlice';
import { fetchStreaks } from '../pages/Home/streakSlice';
import { getAlwaysAvailableProducts, getScheduledProducts } from '../pages/Journal/journalSlice';
import { fetchLanguage } from '../pages/Preferences/languageSlice';
import { showLoading } from '../pages/tabs/tabsSlice';
import { useAppDispatch, useAppSelector } from '../store';
import { useCheckOnline } from './useCheckOnline';

export const useLoadHome = () => {
  const dispatch = useAppDispatch();
  const { online } = useCheckOnline();
  const token = useAppSelector((state) => state.login.authResult.token);
  const hasToken = Boolean(token);

  const loadHome = useCallback(async () => {
    if (online && hasToken) {
      dispatch(showLoading(true));
      await Promise.all([
        dispatch(getScheduledProducts()),
        dispatch(getAlwaysAvailableProducts()),
        dispatch(fetchBadges()),
        dispatch(fetchStreaks()),
        dispatch(fetchLanguage()),
      ]);
      dispatch(showLoading(false));
    }
  }, [dispatch, hasToken, online]);

  return { loadHome };
};
